import React from "react";

const NewHelpMessageButtton = (props) => {
    const { t, Biscuit } = props;
    const currentUrl = new URL(window.location.href);
  return (
    <>
      <a
          href={"help_messages/add" + currentUrl.search}
          id="inb-c-left-bar-add-contingent"
          className={"button beautify beautify-" + Biscuit.get('user.client_id')}
      >
          <i className="fi fi-page-add"></i>
          <span>
              {t('add_${a}',{a:t('help messages',null, 'capital')})}
          </span>
      </a>
    </>
  );
};
export default NewHelpMessageButtton;